//import logo from '../Assets/Imgs/logos/Zeroz-Logo-Horizontal-Black.png';
//import headerGame from '../Assets/Imgs/Header-Images-Game.jpg';
import { OrbitControls } from '@react-three/drei';

import { Canvas } from '@react-three/fiber';
import Sphere from '../Components/Sphere';
import NavBar from '../Components/NavBar';
import Footer from '../Components/Footer';

function Garden() {
  return (
    <div className="App" style={{height:'87vh'}}>
      <NavBar />
      <Canvas className='canvas1'>
        <OrbitControls enableZoom={false} />
        <ambientLight intensity={0.95}/>
        <directionalLight position={[-2,10,2]} intensity={10}/>
        <Sphere/>
        <OrbitControls enableZoom={true} />
        <group>
          <mesh rotation={[-Math.PI / 2, 0, 0]} position = {[0, -3, 0]}>
            <planeGeometry attach='geometry' args={[100, 100]}/>
            <meshStandardMaterial attach='material' color='green'/>
          </mesh>
        </group>
      </Canvas>

      <Footer />
    </div>
  );
}

export default Garden;
